export default {
  baseErrorMessges: {
    required: "Dieses Feld ist erforderlich.",
    dataType: "Dieses Feld hat nicht den richtigen Typ.",
    existingAsset: "Ein Asset mit dieser Kennung existiert bereits.",
    serialNoIsReq: "Kennung ist erforderlich.",
    length: "Der Wert dieses Feldes muss sein",
    min: "Die minimale Länge dieses Feldes wurde nicht erreicht.",
    max: "Die maximale Länge dieses Feldes wurde überschritten.",
    unique: "Es gibt einen Eintrag mit diesem Wert",
    minCount: "Die Eingabe muss mindestens {minCount} Zeichen enthalten.",
    maxCount: "Die Eingabe darf höchstens {maxCount} Zeichen enthalten.",
    dataTypeFloat: "In diesem Feld sind nur Zahlen und bis zu zwei Dezimalstellen erlaubt.",
    dataTypeInt: "In diesem Feld sind nur ganze Zahlen mit maximal 19 Stellen erlaubt.",
    dataTypeString: "In diesem Feld sind nur Buchstaben, Zahlen und Sonderzeichen erlaubt.",
    dataTypeGuid: "Bitte geben Sie eine gültige GUID ein (z.B. 51d52cf1-83c9-4f02-b117-703ecb728b74).",
  },
};
